import React from 'react';

type TrainerCalRestProps = {
  className?: string;
  children?: React.ReactNode;
};

/** Shared Rest label for trainer day grids (Member + Plan). */
export function TrainerCalRest({
  className = 'twp-rest',
  children = 'Rest day',
}: TrainerCalRestProps) {
  return <div className={className}>{children}</div>;
}
